import { Rout_create } from './Rout.create'
import { Rout_to } from './Rout'
import type { ElementId } from '../../../shared/domain/flows'
import type { LoopPath } from '../../../shared/domain/flows/LoopPath.no-deps'

export interface Rout_ReportRoutesArgs {
    ReportApp: React.FunctionComponent<unknown>
    Rpts_View: React.FunctionComponent<unknown>
}

export const Rout_ReportRoutes = (args: Rout_ReportRoutesArgs) => [
    Rout_create('/report/addPhoto/issues', args.ReportApp),
    Rout_create('/report/addUnits/:unitTypeId', args.ReportApp),
    Rout_create('/report/addUnits', args.ReportApp),
    Rout_create('/report/processFlow', args.ReportApp),
    Rout_create('/report/simple-unit', args.ReportApp),
    Rout_create('/report/addNote', args.ReportApp),
    Rout_create('/report/selectProduct', args.ReportApp),
    Rout_create('/report/view/:reportId', args.Rpts_View),
]

export type Rout_ReportPage = 'addPhoto' | 'addUnits' | 'processFlow' | 'simple-unit' | 'addNote' | 'selectProduct'

export function Rout_getReportPage(route: { path: string }): Rout_ReportPage {
    if (route.path === '/report/addPhoto/issues') return 'addPhoto'
    if (route.path === '/report/addUnits/:unitTypeId') return 'addUnits'
    if (route.path === '/report/addUnits') return 'addUnits'
    if (route.path === '/report/processFlow') return 'processFlow'
    if (route.path === '/report/simple-unit') return 'simple-unit'
    if (route.path === '/report/addNote') return 'addNote'
    if (route.path === '/report/selectProduct') return 'selectProduct'
    return 'selectProduct'
}

export function Rout_toPhotoCapture(screen: 'gallery' | 'camera') {
    Rout_to(`/report/addPhoto/issues`, { screen })
}

export function Rout_toReportAddUnits(unitTypeId?: number, parentIds?: number[]) {
    if (unitTypeId != null) {
        Rout_to(`/report/addUnits/${unitTypeId}`, {
            parentIds: parentIds ? parentIds.join(',') : null,
        })
    } else {
        Rout_to(`/report/addUnits`)
    }
}

export function Rout_toProcessFlow() {
    Rout_to(`/report/processFlow`)
}

export function Rout_toSelectProduct() {
    Rout_to(`/report/selectProduct`)
}

export function Rout_toSimpleUnit() {
    Rout_to(`/report/simple-unit`)
}

export function Rout_toReportAddNote() {
    Rout_to(`/report/addNote`)
}

export function Rout_toReportView(
    reportId: number,
    { scrollToElementId, scrollToLoopPath }: { scrollToElementId?: ElementId; scrollToLoopPath?: LoopPath } = {}
) {
    Rout_to(`/report/view/${reportId}`, { scrollToElementId, scrollToLoopPath })
}
